export const ANOMALY_HEADER_TEXT = "Anomaly";
